const VIEWED_JOB_LIST_KEY = `recommended_jobs_viewed_jobs`

export const useViewedJobs = () => {
  const getViewedJobs = () => {
    const viewedJobs = localStorage.getItem(VIEWED_JOB_LIST_KEY)
    return viewedJobs ? JSON.parse(viewedJobs) : []
  }

  const addViewedJob = (jobId: string) => {
    const viewedJobs = getViewedJobs()
    const stringifiedViewedJobs = JSON.stringify([...viewedJobs, jobId])
    localStorage.setItem(VIEWED_JOB_LIST_KEY, stringifiedViewedJobs)
  }

  return {
    viewedJobs: getViewedJobs(),
    addViewedJob,
  }
}
